export namespace Patterns {
  // Mirrors the backend allowlist (accountflow Validation.GENERIC_NAME_PATTERN). A literal space is the
  // only accepted whitespace — matching \s would let tabs and non-breaking spaces past the form and into
  // an API rejection on the next step. Keep the two in sync; widening this set is a backend change first.
  export const GENERIC_NAME = /^[\w !"#$%&'()*+,\-./:;<=>?@[\]`{|}~ÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÑÒÓÔÕÖÙÚÛÜÝàáâãäåçèéêëìíîïñòóôõöùúûüýÿ]*$/u;

  export const MONTH_NUMBER = /^(?:0?[1-9]|1[0-2])$/u;

  export const YEAR_NUMBER = /^20\d{2}$/u;

  export const NUMBER_WITH_FRACTIONAL_PART = /^-?\d+\.\d+$/u;

  export const NUMBER_ONLY = /^-?\d+(?:\.\d{0,2})?$/u;

  export const INITIALS = /\b\w/gu;

  export const EMAIL = /^[\w%+\-.]+@[\d\-.A-Za-z]+\.[A-Za-z]{2,4}$/u;

  export const WORKSPACE = /^[\d\-a-z]{1,64}$/u;

  export const PLACE_OF_BIRTH = /^[\s\d\-a-z]{1,60}$/iu;

  export const SOCIAL_SECURITY_NUMBER = /^(?!666|000|9\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/;

  /**
   * Canadian SIN, unformatted: nine digits, leading digit neither 0 nor 8. Bare digits on purpose - the model holds
   * digits and the formatter inserts the dashes on submit. A lenient pattern would let a separator-bearing value
   * reach a backend that accepts dashes only. The Luhn check digit needs `luhnValidator`.
   */
  export const SOCIAL_INSURANCE_NUMBER = /^(?!0|8)\d{9}$/u;

  /** Canadian Business Number, unformatted: nine digits, non-zero leading digit. Luhn via `luhnValidator`. */
  export const BUSINESS_NUMBER = /^[1-9]\d{8}$/u;

  /** US EIN, unformatted: nine digits. Valid prefixes are checked by `businessTaxIDValidator`. */
  export const BUSINESS_TAX_ID = /^\d{9}$/u;

  export const WEBSITE = /^https?:\/\/(?:w{3}\.)?[\w#%+\-.:=@~]{1,256}\.[\d()A-Za-z]{1,6}\b[\w#%&()+\-./:=?@~]*$/;

  export const MASKED_NUMBER = /[^\d*]|\*(?=\*)/gu;

  export const PERCENT100 = /^(?:100(?:\.0{1,2})?|\d{1,2}(?:\.\d{1,2})?)$/u;

  export const POSITIVE_INTEGER = /^[1-9]\d*$/u;
}
